import {isInJest} from '../../utils';

export const MODAL_ANIMATION_TIMING = isInJest ? 0 : 250;
export const MODAL_CARD_MAX_HEIGHT_VAR = '--local-max-card-height';

/**
 * A work-around for jest. Otherwise, the .toBeVisible() matcher doesn't work
 * correctly when testing modals.
 */
export const INITIAL_OPACITY = isInJest ? 1 : 0;
